{
    "Profile_Summary.attention": "Attention",
    "Profile_Summary.warning": "Warning",
    "Profile_Summary.error": "Error",

    "Profile_Summary.status.quoteAccepted": "Quote Accepted",
    "Profile_Summary.status.quoteIssued": "Quote Issued",
    "Profile_Summary.status.bindRequested": "Bind Requested",
    "Profile_Summary.status.bound": "Bound",
    "Profile_Summary.status.issued": "Issued",
    "Profile_Summary.status.quoted": "Quoted"
}
